import App from "../App";
import { Routes, Route } from "react-router-dom";
import RestaurantLanding from "layouts/restaurant";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<App />}>
        <Route path="/restaurants/:id" element={<RestaurantLanding />} />
        <Route path="/brand/:id" element={<RestaurantLanding />} />
      </Route>
    </Routes>
  );
};

export { AppRoutes };
